import * as React from 'react';

export const YoutubeThumbnail = ({ id }: { id: string }) => (
    <img src={`https://img.youtube.com/vi/${id}/hqdefault.jpg`} alt="" />
);
